module.exports = __webpack_public_path__ + "media/images/patent/x_12-e70a59638830c8fabc8c2a6090ddd6b9.png";